import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class SpinnerService {

  private requestCount = 0;
  private readonly showDelayMs = 300;
  private showTimer?: ReturnType<typeof setTimeout>;

  private _isLoading = new BehaviorSubject<boolean>(false);
  public isLoading$ = this._isLoading.asObservable();

  show(): void {
    this.requestCount++;

    if (this.requestCount === 1) {
      // Avoid flashing the full-screen overlay for fast requests.
      this.showTimer = setTimeout(() => {
        this.showTimer = undefined;
        if (this.requestCount > 0) {
          this._isLoading.next(true);
        }
      }, this.showDelayMs);
    }
  }

  hide(): void {
    this.requestCount--;

    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this.cancelPendingShow();
      this._isLoading.next(false);
    }
  }

  forceHide(): void {
    this.requestCount = 0;
    this.cancelPendingShow();
    this._isLoading.next(false);
  }

  private cancelPendingShow(): void {
    if (this.showTimer !== undefined) {
      clearTimeout(this.showTimer);
      this.showTimer = undefined;
    }
  }
}
